import { Grid, Paper } from '@mui/material';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FundraiserSettingsTabNavigation } from './fundraiserSettingsTabNavigation';

export const FundraiserSettingsLayout = () => {
  const { t } = useTranslation();

  return (
    <GridWrapper>
      <Grid item xs={12} md={4}>
        <MainContentHeader title={t('fundraiser:pageTitle')} />
      </Grid>
      <Grid item xs={12}>
        <Paper>
          <FundraiserSettingsTabNavigation />
          <Outlet />
        </Paper>
      </Grid>
    </GridWrapper>
  );
};
